import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .hasName()
    .hasThumbnail()
    .hasSummary()
    .hasDescription()
    .hasAddress()
    .publishable()
    .hasTimestamps()
    .make();

schema.prop('strapline').setType(String);
schema.prop('telephoneNumber').setType(String);
schema.prop('directionsAndOpening').setType(String);
schema.prop('mapImage').setType(String);

export default schema;
